// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file reports_service.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file reports_service.proto.
 */
export const file_reports_service: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message grpc.api.v1.ReportsParams
 */
export type ReportsParams = Message<"grpc.api.v1.ReportsParams"> & {
  /**
   * @generated from field: int32 begin_date = 2;
   */
  beginDate: number;

  /**
   * @generated from field: int32 end_date = 3;
   */
  endDate: number;

  /**
   * @generated from field: grpc.api.v1.ReportsParams.ReportsBinType bin_type = 4;
   */
  binType: ReportsParams_ReportsBinType;

  /**
   * @generated from field: int32 bins = 5;
   */
  bins: number;
};

/**
 * Describes the message grpc.api.v1.ReportsParams.
 * Use `create(ReportsParamsSchema)` to create a new message.
 */
export const ReportsParamsSchema: GenMessage<ReportsParams> = /*@__PURE__*/
  messageDesc(file_reports_service, 0);

/**
 * @generated from enum grpc.api.v1.ReportsParams.ReportsBinType
 */
export enum ReportsParams_ReportsBinType {
  /**
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: BY_HOURS = 1;
   */
  BY_HOURS = 1,

  /**
   * @generated from enum value: BY_DAYS = 2;
   */
  BY_DAYS = 2,

  /**
   * @generated from enum value: BY_MONTHS = 3;
   */
  BY_MONTHS = 3,

  /**
   * @generated from enum value: BY_YEARS = 4;
   */
  BY_YEARS = 4,

  /**
   * @generated from enum value: OVER_DAY = 12;
   */
  OVER_DAY = 12,

  /**
   * @generated from enum value: OVER_YEAR = 14;
   */
  OVER_YEAR = 14,
}

/**
 * Describes the enum grpc.api.v1.ReportsParams.ReportsBinType.
 */
export const ReportsParams_ReportsBinTypeSchema: GenEnum<ReportsParams_ReportsBinType> = /*@__PURE__*/
  enumDesc(file_reports_service, 0, 0);

/**
 * @generated from message grpc.api.v1.ReportsRequest
 */
export type ReportsRequest = Message<"grpc.api.v1.ReportsRequest"> & {
  /**
   * @generated from field: grpc.api.v1.ReportsParams params = 1;
   */
  params?: ReportsParams | undefined;
};

/**
 * Describes the message grpc.api.v1.ReportsRequest.
 * Use `create(ReportsRequestSchema)` to create a new message.
 */
export const ReportsRequestSchema: GenMessage<ReportsRequest> = /*@__PURE__*/
  messageDesc(file_reports_service, 1);

/**
 * @generated from message grpc.api.v1.GuestsReports
 */
export type GuestsReports = Message<"grpc.api.v1.GuestsReports"> & {
  /**
   * @generated from field: repeated int32 reservations = 3;
   */
  reservations: number[];

  /**
   * @generated from field: repeated int32 guests = 4;
   */
  guests: number[];

  /**
   * @generated from field: repeated int32 returning = 5;
   */
  returning: number[];

  /**
   * @generated from field: repeated int32 cancelations = 6;
   */
  cancelations: number[];

  /**
   * @generated from field: repeated int32 noshows = 7;
   */
  noshows: number[];

  /**
   * @generated from field: repeated float party_size_sums = 8;
   */
  partySizeSums: number[];

  /**
   * @generated from field: repeated float party_size_counts = 9;
   */
  partySizeCounts: number[];
};

/**
 * Describes the message grpc.api.v1.GuestsReports.
 * Use `create(GuestsReportsSchema)` to create a new message.
 */
export const GuestsReportsSchema: GenMessage<GuestsReports> = /*@__PURE__*/
  messageDesc(file_reports_service, 2);

/**
 * @generated from message grpc.api.v1.CampaignReports
 */
export type CampaignReports = Message<"grpc.api.v1.CampaignReports"> & {
  /**
   * @generated from field: string campaign_name = 2;
   */
  campaignName: string;

  /**
   * @generated from field: repeated int32 reservations = 3;
   */
  reservations: number[];

  /**
   * @generated from field: repeated int32 guests = 4;
   */
  guests: number[];

  /**
   * @generated from field: repeated float days_advance_sums = 5;
   */
  daysAdvanceSums: number[];

  /**
   * @generated from field: repeated float days_advance_counts = 6;
   */
  daysAdvanceCounts: number[];
};

/**
 * Describes the message grpc.api.v1.CampaignReports.
 * Use `create(CampaignReportsSchema)` to create a new message.
 */
export const CampaignReportsSchema: GenMessage<CampaignReports> = /*@__PURE__*/
  messageDesc(file_reports_service, 3);

/**
 * @generated from message grpc.api.v1.ServiceReports
 */
export type ServiceReports = Message<"grpc.api.v1.ServiceReports"> & {
  /**
   * @generated from field: int64 service_id = 1;
   */
  serviceId: bigint;

  /**
   * @generated from field: string service_name = 2;
   */
  serviceName: string;

  /**
   * @generated from field: string revenue_currency = 3;
   */
  revenueCurrency: string;

  /**
   * @generated from field: repeated int32 reservations = 4;
   */
  reservations: number[];

  /**
   * @generated from field: repeated int32 guests = 5;
   */
  guests: number[];

  /**
   * @generated from field: repeated float revenue_sums = 6;
   */
  revenueSums: number[];

  /**
   * @generated from field: repeated float revenue_counts = 7;
   */
  revenueCounts: number[];
};

/**
 * Describes the message grpc.api.v1.ServiceReports.
 * Use `create(ServiceReportsSchema)` to create a new message.
 */
export const ServiceReportsSchema: GenMessage<ServiceReports> = /*@__PURE__*/
  messageDesc(file_reports_service, 4);

/**
 * @generated from message grpc.api.v1.WeekdayReports
 */
export type WeekdayReports = Message<"grpc.api.v1.WeekdayReports"> & {
  /**
   * @generated from field: int32 weekday = 1;
   */
  weekday: number;

  /**
   * @generated from field: grpc.api.v1.GuestsReports guests = 3;
   */
  guests?: GuestsReports | undefined;

  /**
   * @generated from field: repeated grpc.api.v1.ServiceReports services = 5;
   */
  services: ServiceReports[];
};

/**
 * Describes the message grpc.api.v1.WeekdayReports.
 * Use `create(WeekdayReportsSchema)` to create a new message.
 */
export const WeekdayReportsSchema: GenMessage<WeekdayReports> = /*@__PURE__*/
  messageDesc(file_reports_service, 5);

/**
 * @generated from message grpc.api.v1.FeedbackReportsBinStars
 */
export type FeedbackReportsBinStars = Message<"grpc.api.v1.FeedbackReportsBinStars"> & {
  /**
   * number of one start (index 0) to five star (index 4) ratings
   *
   * @generated from field: repeated int32 stars = 1;
   */
  stars: number[];
};

/**
 * Describes the message grpc.api.v1.FeedbackReportsBinStars.
 * Use `create(FeedbackReportsBinStarsSchema)` to create a new message.
 */
export const FeedbackReportsBinStarsSchema: GenMessage<FeedbackReportsBinStars> = /*@__PURE__*/
  messageDesc(file_reports_service, 6);

/**
 * @generated from message grpc.api.v1.FeedbackReportsBin
 */
export type FeedbackReportsBin = Message<"grpc.api.v1.FeedbackReportsBin"> & {
  /**
   * @generated from field: grpc.api.v1.FeedbackReportsBinStars overall = 1;
   */
  overall?: FeedbackReportsBinStars | undefined;

  /**
   * @generated from field: grpc.api.v1.FeedbackReportsBinStars food = 2;
   */
  food?: FeedbackReportsBinStars | undefined;

  /**
   * @generated from field: grpc.api.v1.FeedbackReportsBinStars service = 3;
   */
  service?: FeedbackReportsBinStars | undefined;

  /**
   * @generated from field: grpc.api.v1.FeedbackReportsBinStars ambience = 4;
   */
  ambience?: FeedbackReportsBinStars | undefined;
};

/**
 * Describes the message grpc.api.v1.FeedbackReportsBin.
 * Use `create(FeedbackReportsBinSchema)` to create a new message.
 */
export const FeedbackReportsBinSchema: GenMessage<FeedbackReportsBin> = /*@__PURE__*/
  messageDesc(file_reports_service, 7);

/**
 * @generated from message grpc.api.v1.FeedbackReports
 */
export type FeedbackReports = Message<"grpc.api.v1.FeedbackReports"> & {
  /**
   * @generated from field: repeated grpc.api.v1.FeedbackReportsBin bins = 1;
   */
  bins: FeedbackReportsBin[];
};

/**
 * Describes the message grpc.api.v1.FeedbackReports.
 * Use `create(FeedbackReportsSchema)` to create a new message.
 */
export const FeedbackReportsSchema: GenMessage<FeedbackReports> = /*@__PURE__*/
  messageDesc(file_reports_service, 8);

/**
 * @generated from message grpc.api.v1.TabReports
 */
export type TabReports = Message<"grpc.api.v1.TabReports"> & {
  /**
   * @generated from field: int32 tab_id = 1;
   */
  tabId: number;

  /**
   * @generated from field: grpc.api.v1.GuestsReports guests = 3;
   */
  guests?: GuestsReports | undefined;

  /**
   * @generated from field: repeated grpc.api.v1.CampaignReports campaigns = 4;
   */
  campaigns: CampaignReports[];

  /**
   * @generated from field: repeated grpc.api.v1.ServiceReports services = 5;
   */
  services: ServiceReports[];

  /**
   * @generated from field: repeated grpc.api.v1.WeekdayReports weekdays = 6;
   */
  weekdays: WeekdayReports[];

  /**
   * by date created
   *
   * @generated from field: grpc.api.v1.GuestsReports guests_dtc = 13;
   */
  guestsDtc?: GuestsReports | undefined;

  /**
   * by date created
   *
   * @generated from field: repeated grpc.api.v1.CampaignReports campaigns_dtc = 14;
   */
  campaignsDtc: CampaignReports[];

  /**
   * feedbacks by date visited
   *
   * @generated from field: grpc.api.v1.FeedbackReports feedbacks = 21;
   */
  feedbacks?: FeedbackReports | undefined;
};

/**
 * Describes the message grpc.api.v1.TabReports.
 * Use `create(TabReportsSchema)` to create a new message.
 */
export const TabReportsSchema: GenMessage<TabReports> = /*@__PURE__*/
  messageDesc(file_reports_service, 9);

/**
 * @generated from message grpc.api.v1.MsgReports
 */
export type MsgReports = Message<"grpc.api.v1.MsgReports"> & {
  /**
   * @generated from field: string msg_type = 3;
   */
  msgType: string;

  /**
   * @generated from field: repeated int32 sent = 4;
   */
  sent: number[];

  /**
   * @generated from field: repeated int32 errors = 5;
   */
  errors: number[];
};

/**
 * Describes the message grpc.api.v1.MsgReports.
 * Use `create(MsgReportsSchema)` to create a new message.
 */
export const MsgReportsSchema: GenMessage<MsgReports> = /*@__PURE__*/
  messageDesc(file_reports_service, 10);

/**
 * @generated from message grpc.api.v1.TabsReportsResponse
 */
export type TabsReportsResponse = Message<"grpc.api.v1.TabsReportsResponse"> & {
  /**
   * @generated from field: grpc.api.v1.ReportsParams params = 1;
   */
  params?: ReportsParams | undefined;

  /**
   * @generated from field: repeated grpc.api.v1.TabReports tab_reports = 2;
   */
  tabReports: TabReports[];
};

/**
 * Describes the message grpc.api.v1.TabsReportsResponse.
 * Use `create(TabsReportsResponseSchema)` to create a new message.
 */
export const TabsReportsResponseSchema: GenMessage<TabsReportsResponse> = /*@__PURE__*/
  messageDesc(file_reports_service, 11);

/**
 * @generated from message grpc.api.v1.MsgsReportsResponse
 */
export type MsgsReportsResponse = Message<"grpc.api.v1.MsgsReportsResponse"> & {
  /**
   * @generated from field: grpc.api.v1.ReportsParams params = 1;
   */
  params?: ReportsParams | undefined;

  /**
   * @generated from field: repeated grpc.api.v1.MsgReports msg_reports = 2;
   */
  msgReports: MsgReports[];
};

/**
 * Describes the message grpc.api.v1.MsgsReportsResponse.
 * Use `create(MsgsReportsResponseSchema)` to create a new message.
 */
export const MsgsReportsResponseSchema: GenMessage<MsgsReportsResponse> = /*@__PURE__*/
  messageDesc(file_reports_service, 12);

/**
 * @generated from service grpc.api.v1.ReportsService
 */
export const ReportsService: GenService<{
  /**
   * @generated from rpc grpc.api.v1.ReportsService.getTabsReports
   */
  getTabsReports: {
    methodKind: "unary";
    input: typeof ReportsRequestSchema;
    output: typeof TabsReportsResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.ReportsService.getMsgsReports
   */
  getMsgsReports: {
    methodKind: "unary";
    input: typeof ReportsRequestSchema;
    output: typeof MsgsReportsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_reports_service, 0);

